const Quantity = () => {
    if (!String.prototype.getDecimals) {
        String.prototype.getDecimals = function () {
            const num = this;
            const match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);

            if (!match) {
                return 0;
            }

            return Math.max(0, (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0));
        };
    }


    $(document).on('click', '.product-quantity-up, .product-quantity-down', function () {


        const $this = $(this);
        let $qty = $this.siblings('.quantity').first().find('.qty');
        let currentVal = parseFloat($qty.val());
        let max = parseFloat($qty.attr('max'));
        let min = parseFloat($qty.attr('min'));
        let step = $qty.attr('step');

        console.log($this.closest('.quantity'))


        if (!currentVal || currentVal === '' || currentVal === 'NaN') {
            currentVal = 0;
        }

        if (max === '' || max === 'NaN') {
            max = '';
        }
        if (min === '' || min === 'NaN') {
            min = 0;
        }
        if (step === 'any' || step === '' || step === undefined || parseFloat(step) == 'NaN') {
            step = '1';
        }

        if ($this.is('.product-quantity-up')) {
            if (max && (currentVal >= max)) {
                $qty.val(max);
            } else {
                $qty.val((currentVal + parseFloat(step)).toFixed(step.getDecimals()));
            }
        } else {
            if (min && (currentVal <= min)) {
                $qty.val(min);
            } else if (currentVal > 0) {
                $qty.val((currentVal - parseFloat(step)).toFixed(step.getDecimals()));
            }
        }

        $qty.trigger('change');
    });
};


export default Quantity;